import React from "react";

import { useAppDispatch } from "hooks/redux_hooks";
import { SidebarPanelType } from "shared/types";
import { UserType } from "shared/types/user";
import { setSidebarPanel } from "store/reducers/local";

import "./more_participants.scss";

function MoreParticipants({
  users,
  participantBarUserIds,
  isVisibleInClassUserIds,
}: {
  users: UserType[];
  participantBarUserIds: string[];
  isVisibleInClassUserIds: string[];
}) {
  const dispatch = useAppDispatch();
  const numberOfPresentVisibleUsersNotInParticipantBar = users.filter(
    (user) =>
      user.is_present &&
      isVisibleInClassUserIds.includes(user.id) &&
      !participantBarUserIds.includes(user.id),
  ).length;

  if (numberOfPresentVisibleUsersNotInParticipantBar === 0) return null;

  return (
    <button
      className="flex items-center cursor-pointer mb1 more-participants"
      type="button"
      onClick={() => dispatch(setSidebarPanel({ panel: SidebarPanelType.Directory }))}
      data-testid="more-participants"
    >
      +{numberOfPresentVisibleUsersNotInParticipantBar}
    </button>
  );
}

export { MoreParticipants };
